import { ApiInstance, scopedTo } from '@/lib/api'

export interface ImageUploadResult {
  url: string
  id: string
}

export async function uploadImageToApi(file: File, companyId?: string, { signal }: { signal?: AbortSignal } = {}): Promise<ImageUploadResult> {
  const formData = new FormData()
  formData.append('image', file)

  const { data } = await ApiInstance.post<ImageUploadResult>('/images/upload', formData, {
    ...scopedTo(companyId),
    timeout: 60000,
    signal
  })

  return { url: data.url, id: data.id }
}

export async function copyRemoteImage(url: string, name: string): Promise<ImageUploadResult> {
  const response = await fetch(url)
  if (!response.ok) throw new Error(`Não foi possível copiar a foto ${name}`)
  const blob = await response.blob()
  return uploadImageToApi(new File([blob], name, { type: blob.type || 'image/jpeg' }))
}

const IMAGEKIT_TRANSFORM = /([?&])tr=([^&#]*)/

export function imageThumbnail(url: string | null | undefined, width: number, height?: number): string | undefined {
  if (!url) return undefined
  if (!/^https:\/\/ik\.imagekit\.io\//.test(url)) return url
  const transform = height ? `w-${width},h-${height},fo-auto` : `w-${width}`
  if (IMAGEKIT_TRANSFORM.test(url))
    return url.replace(IMAGEKIT_TRANSFORM, (_, prefix: string, current: string) => `${prefix}tr=${current}:${transform}`)
  return `${url}${url.includes('?') ? '&' : '?'}tr=${transform}`
}
